import { memo } from 'react';
import classNames from 'classnames/bind';

import { isMobile } from 'react-device-detect';
import withComponentName from '../../../../../decorators/withComponentName';
import WistiaPlayer from '../../../../Shared/WistiaPlayer';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

function VideoSlide({ url }) {
  return (
    <div className={cx('center')}>
      <WistiaPlayer
        url={url}
        controls
        config={{
          options: isMobile ? { playsinline: false } : {},
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
}

export default memo(withComponentName(VideoSlide));
